/**
 * InfinitSales - DelegationBanner (Etapa 2.2) — HEADLESS
 *
 * O indicador VISUAL de sessão delegada migrou para o NavSidebar (anel âmbar
 * no avatar + borda âmbar no menu + título "Você está acessando o workspace
 * de X") e para o WorkspaceModeModal (boas-vindas one-time). Este componente
 * ficou apenas com a responsabilidade SILENCIOSA de limpar um marcador de
 * delegação obsoleto — quando há delegação salva mas a sessão ativa já não é
 * a delegada (ex.: o usuário relogou na própria conta). Não renderiza nada.
 */
import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getDelegation, clearDelegationMarker } from '../utils/delegation';

const DelegationBanner = () => {
  const { user } = useAuth();
  const delegation = getDelegation();

  // Comparamos TOKENS (fato síncrono do localStorage), não a identidade do
  // AuthContext (que carrega async via getProfile) — comparar user.id criava
  // uma janela em que o marcador era apagado com o realToken dentro,
  // prendendo o usuário no workspace do alvo sem rota de volta.
  const activeToken = localStorage.getItem('token');
  const stale = !!(
    delegation &&
    (delegation.delegatedToken
      ? activeToken !== delegation.delegatedToken
      : user?.id && delegation.targetUserId && user.id !== delegation.targetUserId)
  );

  useEffect(() => {
    if (stale) clearDelegationMarker();
  }, [stale]);

  return null;
};

export default DelegationBanner;
